import { render } from "./RevokeForm.vue?vue&type=template&id=4b071fd5"
import script from "./RevokeForm.vue?vue&type=script&lang=js"
export * from "./RevokeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__